// main imports
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ErrorComponent from "@/modules/shared/ui/ErrorComponent";

// backend
import { getBackend } from "@/lib/backend/backend2";
import * as t2 from "@/lib/backend/users.generated.types";
import { validateNewPassword } from "@/lib/auth";

type Props = {
    show: boolean;
    userUuid: string | null;
    onClose: () => void;
};

type State = {
    error: string | null;
    password: string;
    password2: string;
    userInfo: t2.IGetSingleUserRes | null;
};

/**  Form to edit user's password. */
class UserEditPassword extends Component<Props, State> {
    state: State = {
        error: null,
        password: "",
        password2: "",
        userInfo: null,
    };

    async componentDidMount() {
        await this.fetchData();
    }
    async componentDidUpdate(prevProps: Props) {
        if (prevProps.userUuid !== this.props.userUuid) {
            await this.fetchData();
        }
    }

    async fetchData() {
        try {
            const userUuid = this.props.userUuid;
            if (userUuid !== null) {
                const res_user_data = await getBackend().users.getSingleUser({ id: userUuid });
                this.setState({ userInfo: res_user_data });
            } else {
                this.setState({ userInfo: null });
                return;
            }
        } catch (err) {
            console.log(err);
            this.setState({ error: (err as Error).message });
        }
    }

    async handleSave() {
        try {
            const userUuid = this.props.userUuid;
            if (userUuid !== null) {
                const err = validateNewPassword("<notneeded>", this.state.password, this.state.password2);
                if (err !== "") {
                    throw new Error(err);
                }
                await getBackend().users.setPasswordForUser({
                    uuid: userUuid,
                    password: this.state.password,
                    password2: this.state.password2,
                });
                this.setState({ error: "" });
            }
            this.setState({ error: "" });
            this.props.onClose();
        } catch (err) {
            this.setState({ error: (err as Error).message });
        }
    }

    handleInputChange(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        // read new values
        const target = event.currentTarget;
        let value = target.value;
        if (target.name === "password1") {
            this.setState({ password: value });
        }
        if (target.name === "password2") {
            this.setState({ password2: value });
        }
    }

    render() {
        const { show, onClose } = this.props;
        return (
            <Modal show={show} backdrop="static" dialogClassName="modal-dialog-scrollable" onHide={onClose}>
                <Modal.Header>
                    <Modal.Title>
                        {this.state.userInfo && this.state.userInfo.title} -{" "}
                        <FormattedMessage id="common.password" defaultMessage="Password" />
                    </Modal.Title>
                    <button type="button" className="close" onClick={onClose}>
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">
                            <FormattedMessage id="common.close" defaultMessage="Close" />
                        </span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {this.state.error && <ErrorComponent msg={this.state.error} type="error" />}
                    <div className="form-group">
                        <label>
                            <FormattedMessage id="common.password" defaultMessage="Password" />
                        </label>
                        <input
                            name="password1"
                            type="password"
                            className="form-control"
                            autoComplete="new-password"
                            placeholder=""
                            value={this.state.password}
                            onChange={e => this.handleInputChange(e)}
                        />
                    </div>
                    <div className="form-group">
                        <label>
                            <FormattedMessage id="common.reenter_password" defaultMessage="Re-enter password" />
                        </label>
                        <input
                            name="password2"
                            type="password"
                            className="form-control"
                            placeholder=""
                            autoComplete="new-password"
                            value={this.state.password2}
                            onChange={e => this.handleInputChange(e)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={() => this.handleSave()} disabled={false}>
                        <FormattedMessage id="common.save" defaultMessage="Save" />
                    </button>
                    <button className="btn btn-outline-secondary" onClick={onClose}>
                        <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default UserEditPassword;
